export default __webpack_public_path__ + "static/media/wallet.a1b2529d.svg";